module.exports = __webpack_public_path__ + "media/application/images/ui/buttons-facebook-d9f1673979f77a7a1cd92e4e1ae31b37.png";